import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FurySharedModule } from "src/@fury/fury-shared.module";
import { MaterialModule } from "src/@fury/shared/material-components.module";
import { NgxPaginationModule } from "ngx-pagination";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTabsModule } from "@angular/material/tabs";
import { SharedModule } from "src/app/shared/shared.module";
import { MatButtonModule } from "@angular/material/button";
import { NgxMaskModule } from "ngx-mask";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';

import { ClaimUserDashboardRoutingModule } from "./claim-user-dashboard-routing.module";
import { ClaimUserDashboardComponent } from "./view/claim-user-dashboard.component";
import { ClaimTableComponent } from "./components/grids/claim-table/claim-table.component";
import { ClaimActionsService } from "../customer-dashboard/services/claim-actions.service";
import { PurchaseClaimModule } from "../file-claim/purchase-claim/purchase-claim.module";
import { PayoutClaimModule } from "../file-claim/payout-claim/payout-claim.module";

@NgModule({
  declarations: [ClaimUserDashboardComponent, ClaimTableComponent],
  imports: [
    CommonModule,
    ClaimUserDashboardRoutingModule,
    ReactiveFormsModule,
    FurySharedModule,
    MatTabsModule,
    MatTableModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MaterialModule,
    FormsModule,
    SharedModule,
    MatButtonModule,
    NgxMaskModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    PurchaseClaimModule,
    PayoutClaimModule
  ],
  providers: [ClaimActionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClaimUserDashboardModule {}
